import { createActionCreator } from "common/ReduxUtils";
import { StorageInboundCreateActionTypes } from "../StorageInboundCreateAction.types";
import { StorageInboundCreateState } from "../StorageInboundCreateState.types";

export const setStorageInboundCreateDraft = createActionCreator<Partial<StorageInboundCreateState>>(
  StorageInboundCreateActionTypes.SET_STORAGE_INBOUND_CREATE_DRAFT,
  "storageInboundCreateDraft"
);
